import script from "./UiSettingsButton.vue?vue&type=script&setup=true&lang=js"
export * from "./UiSettingsButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__